exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".CallCenterTitle .pageTitle{text-align:center;color:#00a7f5;font-size:18px;font-weight:900}\n", ""]);

// exports
